var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.client)?_c('div',{staticClass:"wrap-item-client"},[_c('div',{staticClass:"f fm"},[_c('v-icon',{staticClass:"mr8"},[_vm._v("mdi-account-box-multiple")]),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.client.name))])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }